export default "__VITE_ASSET__CslPuQ$c__"